"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleComponent_Weight = exports.TitleComponent_Size = exports.protobufPackage = void 0;
exports.protobufPackage = "title";
var TitleComponent_Size;
(function (TitleComponent_Size) {
    /** NOT_SET - sizing styles are not applied on the client (this variant should be avoided) */
    TitleComponent_Size[TitleComponent_Size["NOT_SET"] = 0] = "NOT_SET";
    TitleComponent_Size[TitleComponent_Size["ONE"] = 1] = "ONE";
    TitleComponent_Size[TitleComponent_Size["TWO"] = 2] = "TWO";
    TitleComponent_Size[TitleComponent_Size["THREE"] = 3] = "THREE";
    TitleComponent_Size[TitleComponent_Size["FOUR"] = 4] = "FOUR";
    TitleComponent_Size[TitleComponent_Size["FIVE"] = 5] = "FIVE";
    TitleComponent_Size[TitleComponent_Size["SIX"] = 6] = "SIX";
    TitleComponent_Size[TitleComponent_Size["SEVEN"] = 7] = "SEVEN";
    TitleComponent_Size[TitleComponent_Size["EIGHT"] = 8] = "EIGHT";
    TitleComponent_Size[TitleComponent_Size["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TitleComponent_Size || (exports.TitleComponent_Size = TitleComponent_Size = {}));
var TitleComponent_Weight;
(function (TitleComponent_Weight) {
    TitleComponent_Weight[TitleComponent_Weight["BOLD"] = 0] = "BOLD";
    /** REGULAR - frontend fallbacks to REGULAR if not provided */
    TitleComponent_Weight[TitleComponent_Weight["REGULAR"] = 1] = "REGULAR";
    TitleComponent_Weight[TitleComponent_Weight["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TitleComponent_Weight || (exports.TitleComponent_Weight = TitleComponent_Weight = {}));
//# sourceMappingURL=title.js.map